import * as React from "react"

export default function CalendarOutlineIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.64 4.83l.36.187v7.65h.667V14H1.333v-1.334H2V4.921l6.005-3.003L13.64 4.83zm-10.307.915v6.921l.667.001v-6h8v6h.667V5.827L7.995 3.414 3.333 5.745zm2 6.922h5.334V11H5.334v1.667zm0-3h5.334V8H5.334v1.666z"
        fill={props.fill}
      />
    </svg>
  )
}
